export const translatePath = (arr, startPoint: number[]) =>
  arr.map(item => [startPoint[0] + item[0], startPoint[1] + item[1]])
